import StoreMgmt from '@/page/store/Mgmt';
import Summary from '@/page/store/sales/Summary';
import SummaryGoods from '@/page/store/sales/Goods';
import SummaryCategory from '@/page/store/sales/Category';
import SummarySupplier from '@/page/store/sales/Supplier';
import SummaryBrand from '@/page/store/sales/Brand';
import SummaryPay from '@/page/store/pay/Summary';
import DeviceMgmt from '@/page/store/device/Mgmt';
import DCategory from '@/page/store/device/Category';

export const store = [{
        path: '/stores/mgmt',
        name: 'storeMgmt',
        component: StoreMgmt,
        meta: {
            requireAuth: true,
            title: '门店管理'
        },
    },
    {
        path: '/stores/sales/summary',
        name: 'summary',
        component: Summary,
        meta: {
            requireAuth: true,
            title: '分店销售日汇总'
        },
    },
    {
        path: '/stores/sales/summary/goods',
        name: 'summaryGoods',
        component: SummaryGoods,
        meta: {
            requireAuth: true,
            title: '商品销售汇总'
        },
    },
    {
        path: '/stores/sales/summary/category',
        name: 'summaryCategory',
        component: SummaryCategory,
        meta: {
            requireAuth: true,
            title: '类别销售汇总'
        },
    },
    {
        path: '/stores/sales/summary/supplier',
        name: 'summarySupplier',
        component: SummarySupplier,
        meta: {
            requireAuth: true,
          title: '供应商销售汇总'
        },
    },
    {
        path: '/stores/sales/summary/brand',
        name: 'summaryBrand',
        component: SummaryBrand,
        meta: {
            requireAuth: true,
            title: '品牌销售汇总'
        },
    },
    {
        path: '/stores/pay/summary',
        name: 'SummaryPay',
        component: SummaryPay,
        meta: {
            requireAuth: true,
            title: '支付汇总'
        },
    },
    {
        path: '/stores/device/mgmt',
        name: 'deviceMgmt',
        component: DeviceMgmt,
        meta: {
            requireAuth: true,
            title: '设备信息'
        },
    },
    {
        path: '/stores/device/category',
        name: 'dCategory',
        component: DCategory,
        meta: {
            requireAuth: true,
            title: '设备类型'
        },
    },

];



// WEBPACK FOOTER //
// ./src/router/store.route.js